/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Pack from './Pack';
import { DirectusFile } from '../helpers/ApiHelper';

type CarouselProps = {
  localeKey: string;
};

export default function Carousel({ localeKey }: CarouselProps) {
  const { t } = useTranslation('', { keyPrefix: 'Packs' });

  const [files, setFiles] = useState<DirectusFile[]>();

  const api = 'https://eterpaz.rdox.ch';

  useEffect(() => {
    try {
      // Get all files
      fetch(`${api}/files`)
        .then((res) => res.json())
        .then((json) => {
          setFiles(json.data);
        });
    } catch (err) {
      console.warn(err);
    }
  }, []);

  const getUrlFromSlug = (slug: string) => files?.find((file) => file.slug === slug);

  /* Besoin des fichiers suivants 

  ## Config
   - E4_PackL
   - E3_PackM
   - G2 Inventaire sport et jeu
   - G3 Inventaire disco
   - G4 Inventaire cinéma
   - G5 Inventaire VTT
   */

  return (
    <div className="carousel">
      <div className="packs">
        {Object.keys(t(localeKey, { returnObjects: true })).map((key) => (
          <Pack
            key={`pack${key}`}
            title={t(`${localeKey}.${key}.name`)}
            surname={t(`${localeKey}.${key}.surname`)}
            subtitle={t(`${localeKey}.${key}.subtitle`)}
            price={t(`${localeKey}.${key}.price`)}
            headerSubtitle={t(`${localeKey}.${key}.headerSubtitle`)}
          >
            {Object.keys(t(`${localeKey}.${key}.items`, { returnObjects: true })).map((itemKey) => (
              <div className="item" key={`pack${key}-${itemKey}`}>
                {itemKey === '0' ? '' : <hr />}
                <h6>{t(`${localeKey}.${key}.items.${itemKey}.title`)}</h6>
                <p>{t(`${localeKey}.${key}.items.${itemKey}.desc`)}</p>
                {t(`${localeKey}.${key}.items.${itemKey}.link`) &&
                getUrlFromSlug(t(`${localeKey}.${key}.items.${itemKey}.link`)) ? (
                  <Link
                    to={`${api}/assets/${
                      getUrlFromSlug(t(`${localeKey}.${key}.items.${itemKey}.link`))?.id
                    }`}
                    target="_blank"
                  >
                    {t(`${localeKey}.${key}.items.${itemKey}.textLink`)}
                  </Link>
                ) : t(`${localeKey}.${key}.items.${itemKey}.link`) ? (
                  <Link to={t(`${localeKey}.${key}.items.${itemKey}.link`) || '#'}>
                    {t(`${localeKey}.${key}.items.${itemKey}.textLink`)}
                  </Link>
                ) : (
                  ''
                )}
              </div>
            ))}
          </Pack>
        ))}
      </div>
    </div>
  );
}
